<div class="overlay" (click)="closeModal()">
  <div class="header">


    <div class="title-wrapper">
      <h3 class="image-title">{{ imageTypeLabel }}</h3>
    </div>

    <button class="close-btn" (click)="closeModal()" aria-label="Close">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="preview-content" (click)="$event.stopPropagation()">
    <button *ngIf="canNavigatePrevious" class="nav-arrow prev-arrow" (click)="previousImage($event)">
      <i class="ti ti-arrow-left"></i>
    </button>

    <button *ngIf="canNavigateNext" class="nav-arrow next-arrow" (click)="nextImage($event)">
      <i class="ti ti-arrow-right"></i>
    </button>

    <div class="image-container">
      <img [src]="imageUrl" class="main-image" (load)="onImageLoad()" (error)="onImageError()"
        [hidden]="isLoading || hasError" alt="{{ imageTitle }}" />

      <div *ngIf="isLoading" class="loading-spinner">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="loading-text">{{ "Loading image..." | translate }}</p>
      </div>

      <div *ngIf="hasError" class="error-message">
        <i class="ti ti-photo-off"></i>
        <p>{{ "Failed to load image" | translate }}</p>
        <small class="error-url">{{ imageUrl }}</small>
      </div>
    </div>
  </div>
</div>